import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';

import type { SignInConsent } from '@core/tellent-types';

/*
 eslint-disable
 @typescript-eslint/consistent-type-assertions,
 @angular-eslint/no-inputs-metadata-property,
*/

@Component({
  imports: [DatePipe],
  template: ` {{ row.createdAt | date: 'YYYY-MM-dd hh:mm ' }} `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  inputs: HistoryComponent.NgInputs,
})
export class HistoryComponent {
  public static readonly NgInputs = ['row' as const];

  public row: SignInConsent;
}
